export function ElitePlansSectionSeparator({
  withMargin = true
}: {
  /** When false, omit top margin only (keep bottom — e.g. first separator under compare). */
  withMargin?: boolean
}) {
  return (
    <hr
      className={`mx-5 mb-10 h-px border-none bg-[#D1D6D6] opacity-60 ${withMargin ? 'mt-10' : 'mt-0'}`}
      aria-hidden='true'
    />
  )
}
